/* unplugin-vue-components disabled */import { render } from "./routelistHebei.vue?vue&type=template&id=2b488c5c&scoped=true"
import script from "./routelistHebei.vue?vue&type=script&lang=js"
export * from "./routelistHebei.vue?vue&type=script&lang=js"

import "./routelistHebei.vue?vue&type=style&index=0&id=2b488c5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b488c5c"]])

export default __exports__